import React, { useEffect } from "react";
import Footer from "../components/Footer";
import Vision from "../components/Vison";
import Mission from "../components/Mission";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (

    <>

    <div className="about-page">
      {/* Hero Section */}
      <section className="hero-about " style={{background: "linear-gradient(to bottom, white 0%, var(--canvas) 100%)"}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge rounded-pill px-3 py-2 mb-3" 
                    style={{background: "var(--chip)", color: "var(--chiptext)"}}>
                About Vions Tech
              </span>
              <h1 className="display-4 fw-bold mb-4" style={{color: "var(--secondarytext)"}}>
                Transforming Ideas Into Scalable Solutions
              </h1>
              <p className="lead mb-4" style={{color: "var(--secondarytext)", opacity: 0.8}}>
                Vions Tech Pvt Ltd is a smart hardware innovation, manufacturing, and services company committed to transforming ideas into scalable, sustainable solutions.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="about-hero-image" style={{
                height: "400px",  }}>


                    <img src="/about_hero.png" alt="About Vions Tech" style={{width: "100%", height: "100%", objectFit: "contain"}} />

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="experience py-5">
        <div className="container">
          <div className="text-center mb-5 section-header">
            <span className="badge rounded-pill px-3 py-2 mb-3" 
                  style={{background: "var(--chip)", color: "var(--chiptext)"}}>
              Our Experience
            </span>
            <h2 className="display-5 fw-bold mb-3" style={{color: "var(--secondarytext)"}}>
              Expertise That Drives Innovation
            </h2>
            <div className="divider mx-auto mb-4"></div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="experience-card h-100 p-4">
                <div className="experience-icon mb-4" style={{
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "var(--chip)",
                  color: "var(--primary)",
                  borderRadius: "50%"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                  </svg>
                </div>
                <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Technical Excellence</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  With over 5 years of R&D expertise in health tech, embedded systems, and product engineering, 
                  we bring deep technical knowledge to every project we undertake.
                </p>
                <ul className="mt-3" style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  <li>Health Tech Solutions</li>
                  <li>Embedded Systems Development</li>
                  <li>Product Engineering</li>
                  <li>Hardware Innovation</li>
                </ul>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="experience-card h-100 p-4">
                <div className="experience-icon mb-4" style={{
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "var(--chip)",
                  color: "var(--primary)",
                  borderRadius: "50%"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Business Acumen</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  With 4 years of business management and strategy experience across multiple MNCs, 
                  our team is well-positioned to drive innovation and operational excellence.
                </p>
                <ul className="mt-3" style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  <li>Business Strategy</li>
                  <li>Operational Excellence</li>
                  <li>Management Consulting</li>
                  <li>Market Analysis</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team py-5" style={{background: "linear-gradient(to bottom, var(--canvas) 0%, white 100%)"}}>
        <div className="container">
          <div className="text-center mb-5 section-header">
            <span className="badge rounded-pill px-3 py-2 mb-3" 
                  style={{background: "var(--chip)", color: "var(--chiptext)"}}>
              Our Foundation
            </span>
            <h2 className="display-5 fw-bold mb-3" style={{color: "var(--secondarytext)"}}>
              Founded by Experts
            </h2>
            <div className="divider mx-auto mb-4"></div>
            <p className="lead mx-auto" style={{maxWidth: "600px", color: "var(--secondarytext)", opacity: 0.8}}>
              Founded by a team of engineering and management graduates, we bring together a unique blend of technical expertise and business acumen to deliver world-class products.
            </p>
          </div>

          <div className="row">
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="team-card h-100 p-4 text-center">
                <div className="team-image mb-4 mx-auto" style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  background: "var(--chip)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--primary)"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h3 className="h5 mb-2" style={{color: "var(--secondarytext)"}}>Engineering Lead</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8, fontSize: "0.9rem"}}>
                  Expertise in hardware innovation and product development with 5+ years of experience.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4">
              <div className="team-card h-100 p-4 text-center">
                <div className="team-image mb-4 mx-auto" style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  background: "var(--chip)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--primary)"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h3 className="h5 mb-2" style={{color: "var(--secondarytext)"}}>Management Lead</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8, fontSize: "0.9rem"}}>
                  Business strategy and operations expert with 4+ years of MNC experience.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4">
              <div className="team-card h-100 p-4 text-center">
                <div className="team-image mb-4 mx-auto" style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  background: "var(--chip)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--primary)"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h3 className="h5 mb-2" style={{color: "var(--secondarytext)"}}>Tech Specialist</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8, fontSize: "0.9rem"}}>
                  Embedded systems and health tech specialist with extensive R&D background.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4">
              <div className="team-card h-100 p-4 text-center">
                <div className="team-image mb-4 mx-auto" style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  background: "var(--chip)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--primary)"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h3 className="h5 mb-2" style={{color: "var(--secondarytext)"}}>Strategy Advisor</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8, fontSize: "0.9rem"}}>
                  Business development and market strategy consultant with MNC background.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values py-5">
        <div className="container">
          <div className="text-center mb-5 section-header">
            <span className="badge rounded-pill px-3 py-2 mb-3" 
                  style={{background: "var(--chip)", color: "var(--chiptext)"}}>
              Our Values
            </span>
            <h2 className="display-5 fw-bold mb-3" style={{color: "var(--secondarytext)"}}>
              The Principles That Guide Us
            </h2>
            <div className="divider mx-auto mb-4"></div>
          </div>

          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="values-card h-100 p-4 text-center">
                <div className="values-icon mb-4 mx-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Innovation</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  We constantly push boundaries to develop groundbreaking technologies that redefine what's possible.
                </p>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div className="values-card h-100 p-4 text-center">
                <div className="values-icon mb-4 mx-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Collaboration</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  We believe in the power of partnerships and work closely with clients to create tailored solutions.
                </p>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div className="values-card h-100 p-4 text-center">
                <div className="values-icon mb-4 mx-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Transformation</h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  We implement technologies that fundamentally improve processes and experiences across industries.
                </p>
              </div>
            </div>
          </div>
        </div>

       
      </section>
      <Vision />
      <Mission />
      <Footer />

      <style>{`
        .about-page {
          font-family: inherit;
        }

        .hero-about{
        padding:6rem 0px;
        }
        
        .divider {
          width: 80px; 
          height: 4px; 
          background: var(--primary);
          border-radius: 999px; 
        }
        
        .experience-card, .team-card, .values-card {
          background: var(--card);
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease;
          border: 1px solid var(--cardborder);
        }
        
        .experience-card:hover, .team-card:hover, .values-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }
        
        .values-icon {
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--chip);
          color: var(--primary);
          border-radius: 50%;
          stroke-width: 1.5;
        }
        
        .values-card:hover .values-icon {
          background: var(--primary);
          color: white;
          transition: all 0.3s ease;
        }
        
        .hero-about ul {
          list-style-type: none;
          padding-left: 0;
        }
        
        .hero-about ul li {
          position: relative;
          padding-left: 1.5rem;
          margin-bottom: 0.5rem;
        }
        
        .hero-about ul li:before {
          content: "•";
          color: var(--primary);
          font-weight: bold;
          position: absolute;
          left: 0;
        }
        
        @media (max-width: 768px) {
          .display-4 {
            font-size: 2.5rem;
          }
        }
      `}</style>
    </div>
    </>
  );
};

export default About;